import { ConditionRegistryItem } from '../../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../../registry/condition/ConditionRegistryCategory';
import { ChoiceOptionState } from '../../../../classes/learnware/LearnwareEnums';
export class ConditionsSelectOption extends ConditionRegistryCategory {
    label = 'Select Option';
    constructor(parent) {
        super(parent);
        super.init();
    }
    selectoption_canbeselected = () => new ConditionRegistryItem({
        label: 'Antwortoption gerade auswählbar (Frage wird derzeit beantwortet)',
        eval: ({ multiSelectOption, questionMultiSelect }) => !!multiSelectOption && !!questionMultiSelect && multiSelectOption.isNotSelected && questionMultiSelect.answeringState.isInAnsweringState
    });
    selectoption_temporaryFalseFeedback = () => new ConditionRegistryItem({
        label: 'SelectOption 1.5s Temporäres "falsch" Feedback',
        eval: ({ multiSelectTask }) => !!multiSelectTask && multiSelectTask.taskUI.shouldShowTemporaryFalseFeedback_1500ms,
    });
    selectoption_CorrectDone = () => new ConditionRegistryItem({
        label: 'OptionState CorrectDone',
        eval: ({ multiSelectOption }) => !!multiSelectOption && multiSelectOption.optionUI.choiceOptionUIState === ChoiceOptionState.CorrectDone
    });
    selectoption_CorrectPending = () => new ConditionRegistryItem({
        label: 'OptionState CorrectPending',
        eval: ({ multiSelectOption }) => !!multiSelectOption && multiSelectOption.optionUI.choiceOptionUIState === ChoiceOptionState.CorrectPending
    });
    selectoption_Wrong = () => new ConditionRegistryItem({
        label: 'OptionState Wrong',
        eval: ({ multiSelectOption }) => !!multiSelectOption && multiSelectOption.optionUI.choiceOptionUIState === ChoiceOptionState.Wrong
    });
    selectoption_ShouldHaveBeenSelected = () => new ConditionRegistryItem({
        label: 'OptionState ShouldHaveBeenSelected',
        eval: ({ multiSelectOption }) => !!multiSelectOption && multiSelectOption.optionUI.choiceOptionUIState === ChoiceOptionState.ShouldHaveBeenSelected
    });
    selectoption_Correct2 = () => new ConditionRegistryItem({
        label: 'OptionState CorrectDone, CorrectPending or ShouldHaveBeenSelected',
        eval: ({ multiSelectOption }) => !!multiSelectOption && multiSelectOption.optionUI.shouldOptionBeGreen
    });
}
